import { render, staticRenderFns } from "./EpiAutoCompleteInput.vue?vue&type=template&id=0b70b973&scoped=true"
import script from "./EpiAutoCompleteInput.vue?vue&type=script&lang=js"
export * from "./EpiAutoCompleteInput.vue?vue&type=script&lang=js"
import style0 from "./EpiAutoCompleteInput.vue?vue&type=style&index=0&id=0b70b973&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70b973",
  null
  
)

export default component.exports